// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfigurationConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get REQUIRE_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('EMAIL_MESSAGE_CONSTRAINT')
      }
    };
  },
  get INTERVAL_REQUIRE_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('EMAIL_MESSAGE_CONSTRAINT')
      },
      numericality: {
        greaterThanOrEqualTo: 1,
        get notGreaterThanOrEqualTo() {
          return localizer.getText('SYSTEM_CONFIGURATION_EXPORTING_CONSTRAINT_MESSAGE_TIME_INTERVAL');
        }
      }
    };
  },
  get STORAGE_TYPES(){
    return [
      {
        title: 'Disk', 
        value: 1
      },
      {
        title: 'AzureFileService', 
        value: 2
      },
      {
        title: 'AWSS3Bucket', 
        value: 3
      }
    ]
  },
  min: 0,
  max: 2000000000
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ExportingConfigurationConstants.js